import styled from 'styled-components';
import ArticleTileSkeleton from './ArticleTileSkeleton';

const Wrapper = styled.div`
.articleListSkeleton {
  .article-item {
    background-color: transparent;
    .loading-image {
      border-radius: 4px;
      width: 30px;
      height: 24px;
    }
  }
  .profile-area {
    width: 30px;
    height: 24px;
    min-width: 24px;
  }
  .text-area {
    min-width: 65%;
  }
}
  
`;
const ArticleListViewSkeleton = function ArticleListViewSkeleton() {
  return (
    <Wrapper>
      <div className="articleListSkeleton">
        {[1, 2, 3, 4, 5].map(() => (
          <ArticleTileSkeleton />
        ))}
      </div>
    </Wrapper>
  );
};
export default ArticleListViewSkeleton;
